import { useEffect, useState } from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { DateTime } from 'luxon';
import RsrcFilterModel from "../../../filter/RsrcFilterModel.js";
const DEFAULT_PATHS = [];
export default function useLoadPaths(opts) {
  const {
    rsrcDelegate,
    pathPrefix
  } = opts;
  const [paths, setPaths] = useState(DEFAULT_PATHS);
  const [pathsError, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const load = async () => {
      if (!pathPrefix) {
        setPaths(DEFAULT_PATHS);
        setError(null);
        return;
      }

      // This query is not performant over ~24 hours, so limiting it to that
      const now = DateTime.now();
      const range = {
        start: now.minus({
          hours: 24
        }).toUTC().toISO(),
        end: now.toUTC().toISO()
      };
      const id = rsrcDelegate.parent().id;
      let filter = RsrcFilterModel.create();
      filter = RsrcFilterModel.setFilter(filter, 'createdAt', range);
      filter = RsrcFilterModel.setFilter(filter, 'path', pathPrefix);
      const pathSplits = (pathPrefix?.match(/\//g) || []).length + 2;
      const opts = {
        queryName: `${id}.rsrc.timeline.groups`,
        group: 'name',
        attributes: `split_part(path, '/',${pathSplits}) as name,count(id) as count`,
        returnSignedUrl: false,
        returnCount: false,
        order: 'count DESC',
        filter: RsrcFilterModel.toRsrcFilter(filter)
      };
      try {
        setLoading(true);
        const response = await GlobalState.dispatch(rsrcDelegate.search(opts));
        if (response.items.length > 0) {
          setPaths(response.items.map(i => ({
            name: `${pathPrefix}/${i.name}`,
            count: parseInt(i.count)
          })).sort((a, b) => {
            return a.name.localeCompare(b.name);
          }));
        } else {
          setPaths(DEFAULT_PATHS);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [rsrcDelegate, pathPrefix]);
  return {
    paths,
    pathsError,
    loading
  };
}